import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 35,
	viewBox: "0 0 35 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 17.5,
		cy: 17.5,
		r: 17,
		stroke: "#003B6F"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.653 24.8569H11.8482L16.5261 19.5364L20.2458 24.8569H24.357L18.8136 16.9669L23.9037 11.1426H22.6878L18.2675 16.1809L14.723 11.1426H10.6427L16.0007 18.7807L10.653 24.8569ZM12.2913 12.0394H14.1357L22.6981 24.0104H20.8331L12.2913 12.0394Z",
		fill: "#003B6F"
	})]
});
export default SvgXIcon;
